export type PerformanceBenchmark = ReportMetrics & ReportTimeRange;

export interface ReportMetrics {
  revenue: number;
  newRevenue?: number;
  repeatRevenue?: number;
  totalCustomers: number;
  newCustomers?: number;
  repeatCustomers?: number;
  avgTransaction: number;
}

interface ReportTimeRange {
  startDate: string;
  endDate: string;
}

export interface PerformanceData {
  summary: PerformanceBenchmark;
  periods: PerformanceBenchmark[];
}

export type ReportTypes =
  | 'Year by Quarters'
  | 'Year by Months'
  | 'Quarter by Months';

export const testReportDetails: PerformanceData = {
  summary: {
    revenue: 123444,
    newRevenue: 48629,
    repeatRevenue: 74815,
    totalCustomers: 3300,
    newCustomers: 1300,
    repeatCustomers: 2000,
    avgTransaction: 123444 / 3300,
    startDate: '2019-01-01',
    endDate: '2019-04-31',
  },
  periods: [
    {
      revenue: 123444 / 4 - 100,
      newRevenue: 48629 / 4 - 100,
      repeatRevenue: 74815 / 4 - 100,
      totalCustomers: 3300 / 4 - 100,
      newCustomers: 1300 / 4 - 100,
      repeatCustomers: 2000 / 4 - 100,
      avgTransaction: 123444 / 3300 / 4 - 100,
      startDate: '2019-01-01',
      endDate: '2019-01-31',
    },
    {
      revenue: 123444 / 4 + 100,
      newRevenue: 48629 / 4 - 100,
      repeatRevenue: 74815 / 4 + 100,
      totalCustomers: 3300 / 4 - 100,
      newCustomers: 1300 / 4 + 100,
      repeatCustomers: 2000 / 4 + 100,
      avgTransaction: 123444 / 3300 / 4 + 100,
      startDate: '2019-02-01',
      endDate: '2019-02-28',
    },
    {
      revenue: 123444 / 4 - 100,
      newRevenue: 48629 / 4 - 100,
      repeatRevenue: 74815 / 4 + 100,
      totalCustomers: 3300 / 4 - 100,
      newCustomers: 1300 / 4 - 100,
      repeatCustomers: 2000 / 4 - 100,
      avgTransaction: 123444 / 3300 / 4 - 100,
      startDate: '2019-03-01',
      endDate: '2019-03-31',
    },
    {
      revenue: 123444 / 4 + 100,
      newRevenue: 48629 / 4 - 100,
      repeatRevenue: 74815 / 4 + 100,
      totalCustomers: 3300 / 4 - 100,
      newCustomers: 1300 / 4 + 100,
      repeatCustomers: 2000 / 4 + 100,
      avgTransaction: 123444 / 3300 / 4 + 100,
      startDate: '2019-04-01',
      endDate: '2019-04-31',
    },
  ],
};
